<template>
    <button class="mg-btn-gold" color="primary" text-color="whiteprimary"  v-on:click="modalOpen">Add Priority</button>    
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#priorityModals" id="addPriorityBtn"> </button>             
    <div class="modal fade right" id="priorityModals" tabindex="-1" style="display: none;" aria-hidden="true"  data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="staticBackdropLabel">
        <div class="modal-dialog modal-dialog-centered">            
            <div class="modal-content">
                <div class="modal-header">
                    <input type="hidden" name="priorityEditId" id="priorityEditId">
                    <h5 class="modal-title">{{ modalType }} Priority</h5> 
                    <button type="button" class="btn-close" id="closePop" data-bs-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <form @submit.prevent="onSubmit" class="priorityFrm" id="priorityFrm">
                    <div class="modal-body setformbackform">
                        <div class="row">
                            <div class="col-sm-12">
                                <span v-if="errorMessage != ''">
                                    <p class="alert alert-danger error-msg" >{{ errorMessage }}</p>
                                </span>
                            </div>
                        </div> 
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="formmginput-controlx mb-2"> 
                                    <label for="priorityName" class="form-label">Priority Name<span class="requiredCls">*</span></label> 
                                    <input type="text" class="form-control" name="priorityName" id="priorityName" placeholder="Enter priority name"  v-model="v$.form.priorityName.$model"> 
                                    <div class="input-errors" v-for="(error, index) of v$.form.priorityName.$errors" :key="index">
                                        <div class="error-msg">{{ error.$message }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div class="modal-footer">                           
                        <button type="button" class="mg-btn-gold" id="saveUpdateBtn" :disabled="v$.form.$invalid" v-on:click="addPriority" v-if="formLoader === 1">{{ buttonName }}</button>
                        <button type="button" class="mg-btn-gold" id="saveUpdateBtn" :disabled="v$.form.$invalid" v-else><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Loading...</button>
                    </div>
                
                </form>
            </div>
        </div>
    </div>

</template>
<script>
import useVuelidate from '@vuelidate/core'
import {
    required,
    // maxLength,
    minLength
} from '@vuelidate/validators'
import $ from "jquery";
import axios from 'axios'
export default {
    name: 'AddEditPriority',
    emits: ['reloadTableData'], 
    data() {
        return {
            img_url: process.env.VUE_APP_IMG_URL,
            modalType: 'Add',
            buttonName: 'Save',
            errorMessage: '',
            formLoader: 1,
            logoFile: null,
            form: {
                priorityName: '',
            },
        }
    },
    methods: {
        async modalOpen() {
            this.errorMessage = ''
            this.form.priorityName = '';
            
            this.modalType = 'Add';
            this.buttonName = 'Save',
            this.logoFile = null,
            this.v$.$reset()
            document.getElementById('priorityEditId').value = '';
            document.getElementById('addPriorityBtn').click();
            setTimeout(async () =>
                $("#priorityName").focus(),
            500);
        },
        async addPriority() {
            this.formLoader = 2
            let _post = {}
            let _URL = ''
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
            var priorityName = $('#priorityName').val();
            if (this.modalType == 'Edit') {
                _URL = process.env.VUE_APP_API_URL + 'priority/update'
                var priority_id = $('#priorityEditId').val();
                _post = {
                    priority_id: priority_id,
                    priority: priorityName,
                }
            } else {
                _URL = process.env.VUE_APP_API_URL + 'priority/create'
                _post = {
                    priority: priorityName,
                }
            }
            await axios.post(_URL, _post)
                .then((resp) => {
                if (resp.status == 200 && resp.data.status == 'success') {
                    document.getElementById('closePop').click();
                    this.$toast.success(resp.data.message);
                    this.$store.state.priority.loadPriorityData = 1
                    this.$emit('reload-table-data');
                } else if (resp.status == 200 && resp.data.status == 'failure') {
                    this.errorMessage = resp.data.message;
                }
                    this.formLoader = 1
            })
                .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                console.log("response", error.response.status);
                console.log("message", error.response.data.message);
                this.errorRes = error.response.data.message;
                this.formLoader = 1
            })            
        },
        async modalEditOpen() {
            let priority_id = $('.priorityValId').val();
            $('.loadimg').show();
            this.errorMessage = ''
            this.form.priorityName = '';
            this.modalType = 'Edit',
            this.buttonName = 'Update',
            document.getElementById('priorityName').value = '';
            this.v$.$reset()
            this.formLoader = 2
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
            await axios.post(process.env.VUE_APP_API_URL + 'priority/get', {
                priority_id: priority_id
            })
            .then((resp) => {
                if (resp.status == 200 && resp.data.status == 'success') {
                    document.getElementById('priorityName').value = resp.data.data.priority;
                    document.getElementById('priorityEditId').value = resp.data.data._id;
                    this.v$.form.priorityName.$model = resp.data.data.priority;
                    document.getElementById('addPriorityBtn').click();
                    this.v$.$reset()
                    $('.loadimg').hide();
                    setTimeout(async () =>
                        $("#priorityName").focus(),
                    500);
                }
                this.formLoader = 1
            })
            .catch(error => {
                // this.errorMessage = error.message;
                console.error("There was an error!", error);
                console.log("response", error.response.status);
                console.log("message", error.response.data.message);
                this.formLoader = 1
                // this.errorRes = error.response.data.message;
            })
        },
    },
    setup() {
        return {
            v$: useVuelidate()
        }
    },
    validations() {
        return {
            form: {
                priorityName: {
                    required,
                    min: minLength(2)
                },
            },
        }
    },
}
</script>